import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../utils/axiosInstance";

const baseApi = createApi({
    reducerPath: "baseApi",
    baseQuery: axiosBaseQuery({ baseUrl: "/api" }),
    endpoints: (builder) => ({}),
    tagTypes: ["Auth"],
})

export default baseApi;